import { brand, faqs, professionals } from '../data/site'
import { absoluteUrl, SITE_NAME, SITE_URL } from './seo'

const postalAddress = {
  '@type': 'PostalAddress',
  streetAddress: brand.addressLine1,
  addressLocality: 'Ocala',
  addressRegion: 'FL',
  postalCode: '34476',
  addressCountry: 'US',
}

const directoryPeople = professionals.flatMap((professional) =>
  professional.name.includes(' & ')
    ? professional.name.split(' & ').map((name) => ({ ...professional, name }))
    : [professional],
)

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${SITE_URL}/#business`,
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  logo: absoluteUrl('/diamondlogo.png'),
  image: absoluteUrl('/og.png'),
  telephone: brand.phoneDisplay,
  email: brand.email,
  address: postalAddress,
  hasMap: brand.mapUrl,
  sameAs: [brand.facebook, brand.instagram],
}

export const directorySchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Independent professionals at Diamond Suites Ocala',
  url: absoluteUrl('/directory/'),
  numberOfItems: directoryPeople.length,
  itemListElement: directoryPeople.map((professional, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: {
      '@type': 'Person',
      name: professional.name,
      jobTitle: professional.title,
      ...(professional.businessName ? { worksFor: { '@type': 'Organization', name: professional.businessName } } : {}),
      ...(professional.bio ? { description: professional.bio.join(' ') } : {}),
      ...(professional.image ? { image: absoluteUrl(`/images/${professional.image}`) } : {}),
      ...(professional.phone ? { telephone: professional.phone } : {}),
      workLocation: {
        '@type': 'Place',
        name: SITE_NAME,
        address: postalAddress,
      },
    },
  })),
}

export const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  })),
}

export const directoryStructuredData = [localBusinessSchema, directorySchema]
export const faqStructuredData = [localBusinessSchema, faqSchema]
